import { render, staticRenderFns } from "./TableCostAgricola.vue?vue&type=template&id=0a4a654e"
import script from "./TableCostAgricola.vue?vue&type=script&lang=js"
export * from "./TableCostAgricola.vue?vue&type=script&lang=js"
import style0 from "./TableCostAgricola.vue?vue&type=style&index=0&id=0a4a654e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports